import { Component, OnDestroy, OnInit,EventEmitter,Output } from '@angular/core';
import { RuleEngineService } from '../../services/rule-engine.service';
import { Subscription } from 'rxjs';
import { DataParserService } from '../../services/data-parser.service';
import { FileNode, Rule } from '../models/rule-engine';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { NestedTreeControl } from '@angular/cdk/tree';
import { HttpClient } from '@angular/common/http';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { O } from '@angular/cdk/keycodes';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-template-tree',
  templateUrl: './template-tree.component.html',
  styleUrls: ['./template-tree.component.scss'],
})
export class TemplateTreeComponent implements OnInit, OnDestroy {
  @Output() closeEvent = new EventEmitter<void>();
  //#region variables
  // fileName: string = '';
  jsonData: any;
  copyOfJsonData: any;
  jsonForMatTree: any;
  copyOfJsonForMatTree: any;
  uniqueId: number = 0;
  leafNode: any;
  pathExpression: string[] = [];
  listOfRules: Rule[] = [];
  currentRuleCardNumber?: number;
  allPathsForAutoSuggestion: string[] = [];
  enableJsonTree: boolean = false;
  selectedButton: string ='';

  // private httpClient:HttpClient;
  private _getChildren = (node: FileNode) => node.children;
  private xmlData: any;
  private _ruleEngineService: RuleEngineService;
  private _ruleEngineServiceSubscription!: Subscription;
  private _dataParserService: DataParserService;
  private _dataParserServiceSubscription!: Subscription;
  private _matTreeJsonSubscription!: Subscription;

  nestedDataSource!: MatTreeNestedDataSource<FileNode>;
  nestedTreeControl: NestedTreeControl<FileNode>;
  hasNestedChild = (_: number, node: FileNode) =>
    !!node.children && node.children.length > 0;
  
  //#endregion

  //#region constructor
  constructor(
    private toastr: ToastrService,
    ruleEngineService: RuleEngineService,
    dataParserService: DataParserService,
    httpClient: HttpClient,
    private ngxUiLoaderService: NgxUiLoaderService
  ) {
    this._ruleEngineService = ruleEngineService;
    this._dataParserService = dataParserService;
    this.nestedTreeControl = new NestedTreeControl<FileNode>(this._getChildren);
    this.nestedDataSource = new MatTreeNestedDataSource();
    // this.httpClient = httpClient;
  }
  //#endregion

  //#region life cycle hooks
  ngOnInit(): void {
    //this.getFileName();
    this._dataParserService.getJsonDataForMatTree();
    //this.assignTheJsonForMatTreeToMatTree();
    // this._dataParserService.loadAPData();
    this.onClickAP();
    this._matTreeJsonSubscription = this._dataParserService.$getMatTreeJson.subscribe({
      next: (data) => {
        this.jsonForMatTree = data;
        this.assignTheJsonForMatTreeToMatTree();
      },
      error: () => {
        this.toastr.error("Unable to generate mat tree", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
      }
    })

  }

  ngOnDestroy(): void {
    if (this._ruleEngineServiceSubscription) {
      this._ruleEngineServiceSubscription.unsubscribe();
    }
    if (this._dataParserServiceSubscription) {
      this._dataParserServiceSubscription.unsubscribe();
    }
    this.selectedButton='';
  }
  //#endregion
  
  async onFileUpload(event: any) {
    this.selectedButton='upload'
     if (event.target.files.length) {
       //setting the filename using the service's behavior subject and then that will emit this value to the templete-tree component
       this._ruleEngineService.setFileName(event.target.files[0].name);
       //reading the content of the file
       this.xmlData = await this.readTheContentOfTheUploadedFile(event.target.files[0]);
       //sending the xml data to the service to convert the json and the emit the value to the template-tree component
       this._dataParserService.parseXmlToJson(this.xmlData);
     }
   }


   private async readTheContentOfTheUploadedFile(file: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = () =>{
        reject(new Error('Error reading file'));
      }
      reader.readAsText(file);
    });
  }

  // private getFileName() {
  //   this._ruleEngineServiceSubscription = this._ruleEngineService
  //     .getFileName()
  //     .subscribe({
  //       next: (fileName) => {
  //         this.fileName = fileName;
  //       },
  //       error: (err) => {
  //         this.toastr.error("Unable to get file name", "", {
  //           timeOut: 4000,
  //           positionClass: 'toast-bottom-right'
  //         });
  //       }
  //     });
  // }

  private assignTheJsonForMatTreeToMatTree() {
    this.nestedDataSource.data = this.jsonForMatTree;
    this.nestedTreeControl.dataNodes = this.jsonForMatTree;
    this.nestedTreeControl.expandAll();
  }

  // private buildFileTreeForMatTreeUsingRawJson(jsonData: any): FileNode[] {
  //   const result: FileNode[] = [];
    
  //   Object.keys(jsonData).forEach(key => {
  //     const value = jsonData[key];
  
  //     if (value === null || value === undefined) {
  //       // If value is null/undefined, create a node with a null leaf
  //       const node: FileNode = { key: key, uniqueId: this.uniqueId++, leaf: null };
  //       result.push(node);
  //     } else if (Array.isArray(value)) {
  //       // If the value is an array...
  //       if (value.length > 0 && typeof value[0] === 'object') {
  //         // Array of objects: flatten it.
  //         // For each item in the array, create a node with the same key.
  //         value.forEach(item => {
  //           const node: FileNode = { key: key, uniqueId: this.uniqueId++ };
  //           const children = this.buildFileTreeForMatTreeUsingRawJson(item);
  //           if (children.length > 0) {
  //             node.children = children;
  //           }
  //           result.push(node);
  //         });
  //       } else {
  //         // Array of primitives: create one node with children for each element.
  //         const node: FileNode = { key: key, uniqueId: this.uniqueId++ };
  //         node.children = value.map(item => ({
  //           key: key,
  //           uniqueId: this.uniqueId++,
  //           leaf: item
  //         }));
  //         result.push(node);
  //       }
  //     } else if (typeof value === 'object') {
  //       // If the value is an object (but not an array), recursively process it.
  //       const node: FileNode = { key: key, uniqueId: this.uniqueId++ };
  //       const children = this.buildFileTreeForMatTreeUsingRawJson(value);
  //       if (children.length > 0) {
  //         node.children = children;
  //       }
  //       result.push(node);
  //     } else {
  //       // If the value is a primitive, just create a leaf node.
  //       const node: FileNode = { key: key, uniqueId: this.uniqueId++, leaf: value };
  //       result.push(node);
  //     }
  //   });
    
  //   return result;
  // }
  




  onNodeClick(node: FileNode) {
    this.checkForLeafNodeForGeneratingPath(node);
    this.pathExpression = this.findPathExpression(
      this._dataParserService.jsonForMatTree,
      node.key,
      node.uniqueId
    );
    this.pathExpression?.pop();
    this.pathExpression.push(node.key);
    if (!node?.children?.length) {
      this.pathExpression.pop();
      this.pathExpression.push(`@${node.key}`);
      this.sendTheDataFromTemplateToCreateRulesComponent(this.pathExpression);
    }
  }

  private checkForLeafNodeForGeneratingPath(node: FileNode) {
    if (!node?.children?.length) {
      this.leafNode = node;
    } else {
      this.leafNode = undefined;
    }
  }

  findPathExpression(
    jsonForMatTree: any,
    targetName: any,
    uniqueId: number,
    path = []
  ): any {
    for (const item of jsonForMatTree) {
      // Add the current item's name to the path
      const currentPath: any = [...path, item.key];

      // If the current item's name matches the target name, return the path
      if (item.key === targetName && item.uniqueId == uniqueId) {
        return currentPath;
      }

      // If the current item has children, search within the children
      if (item.children) {
        const result = this.findPathExpression(
          item.children,
          targetName,
          uniqueId,
          currentPath
        );
        if (result) {
          return result;
        }
      }
    }

    // Return null if the name is not found in the current branch
    return null;
  }

  // private getJsonDataForMatTree(): any {
  //   this._dataParserServiceSubscription = this._dataParserService
  //     .$getJsonDataForMatTree()
  //     .subscribe({
  //       next: (jsonData) => {
  //         if(jsonData !== null){
  //           this.jsonData = jsonData;
  //           this.copyOfJsonData = structuredClone(this.jsonData);
  //           this.enableTree();
  //         }          
  //       },
  //       error: (err) => {this.toastr.error("Unable to generate mat tree", "", {
  //         timeOut: 4000,
  //         positionClass: 'toast-bottom-right'
  //       });}
  //     });
  // }

  // private enableTree() {
  //   if (this.jsonData) {
  //     this.jsonForMatTree = this.buildFileTreeForMatTreeUsingRawJson(
  //       this.jsonData
  //     );
  //     this.copyOfJsonForMatTree = structuredClone(this.jsonForMatTree);
  //     this.assignTheJsonForMatTreeToMatTree();
  //     this._dataParserService.setNodePaths(
  //       this.collectAllPaths(this.jsonForMatTree)
  //     );
  //     this._dataParserService.setNodesWithTheirLeafNodes(
  //       this.collectNodesWithLeaves(this.jsonForMatTree)
  //     );
  //   }
  // }

  sendTheDataFromTemplateToCreateRulesComponent(pathExpression: any) {
    this._ruleEngineService.setPath(pathExpression);
  }
  // collectAllPaths(jsonForMatTree: any, path = [], paths: string[] = []): any {
  //   for (const item of jsonForMatTree) {
  //     // Add the current item's name to the path
  //     const currentPath: any = [...path, item.key];

  //     // If the current item's name matches the target name, return the path
  //     // if (item.key === targetName && item.uniqueId == uniqueId) {
  //     //   return currentPath;
  //     // }
  //     if (!item.children) {
  //       const modifiedPath = [...path, `@${item.key}`].join('/');
  //       paths.push(modifiedPath);
  //     }

  //     // If the current item has children, search within the children
  //     if (item.children) {
  //       paths.push(...this.collectAllPaths(item.children, currentPath));
  //     }
  //   }
  //   return paths;

  // }

  // collectNodesWithLeaves(tree: FileNode[]): { nodeName: string, leafNodes: string[] }[] {
  //   const nodesWithLeaves: { nodeName: string, leafNodes: string[] }[] = [];
  
  //   // Recursive function to traverse the tree
  //   const traverse = (treeNodes: FileNode[], currentPath: string[] = []) => {
  //     for (const node of treeNodes) {
  //       const currentPathWithNode = [...currentPath, node.key];
  
  //       if (node.children) {
  //         // Recursively process child nodes
  //         traverse(node.children, currentPathWithNode);
  //       } else {
  //         // Leaf node found
  //         const parentNodeName = currentPath.join('/');
  //         const leafNode = `@${node.key}`;
  
  //         // Add leaf to its parent's entry or create a new one
  //         const parentNode = nodesWithLeaves.find(n => n.nodeName === parentNodeName);
  //         if (parentNode) {
  //           parentNode.leafNodes.push(leafNode);
  //         } else {
  //           nodesWithLeaves.push({ nodeName: parentNodeName, leafNodes: [leafNode] });
  //         }
  //       }
  //     }
  //   };
  
  //   traverse(tree);
  
  //   return nodesWithLeaves;
  // }  

  public onClickAP() {
    this.selectedButton = 'AP';
    this._dataParserService.loadAPData();
  }


  public onClickCP() {
    this.selectedButton = 'CP';
    this._dataParserService.loadCPData();
  }

  onTemplateClose(){
    this.closeEvent.emit();
  }
}
